/** מדריך התקנה — תמיד בעברית */
export function getInstallGuideLocale() {
  return "he";
}

const COPY = {
  title: "הוסף למסך הבית",
  subtitle: "4 צעדים — לחץ בדיוק על מה שמסומן",
  devPreview: "תצוגה מקדימה",
  openInSafari: "קודם פתח ב-Safari",
  openInSafariAction: "⋮ → «פתח ב-Safari»",
  steps: {
    menu: {
      title: "לחץ ⋮",
      hint: "שלוש נקודות בסרגל התחתון, ליד reshet.app",
    },
    share: {
      title: "«שיתוף»",
      hint: "בתפריט שנפתח (Share)",
    },
    more: {
      title: "«עוד…»",
      hint: "בשורת הפעולות — ליד «העתק» / «סימניות»",
    },
    add: {
      title: "«הוסף למסך הבית»",
      hint: "גלול למטה אם צריך — ואז «הוסף»",
    },
  },
  ui: {
    share: "שיתוף",
    addToBookmarks: "הוסף לסימניות",
    addBookmarkTo: "הוסף סימנייה ל…",
    newTab: "כרטיסייה חדשה",
    newPrivateTab: "כרטיסייה פרטית חדשה",
    copy: "העתק",
    addToReadingList: "הוסף לרשימת הקריאה",
    more: "עוד…",
    addToHomeScreen: "הוסף למסך הבית",
    addToFavourites: "הוסף למועדפים",
    findOnPage: "חפש בדף",
    freeform: "Freeform",
    chrome: "Chrome",
  },
  scrollHint: "גלול למטה ברשימה",
  siteName: "הרשת",
  bannerTitle: "הוסף את הרשת למסך הבית",
  bannerSubtitle: "לגישה מהירה מהמסך הבית",
  howButton: "איך?",
  installButton: "התקן",
};

export function getInstallGuideCopy() {
  return COPY;
}
